import React from 'react';
import Button from '@material-ui/core/Button';
import {withStyles} from "@material-ui/core";
import {Styles} from "../../../../config/design/styles";
import {connect} from "trim-redux";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {Link} from "react-router-dom";
import {Translate} from "../../../../config/Translate";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import Typography from "@material-ui/core/Typography/Typography";
import {defaultVariabls} from "../../../../config";
import FormHelperText from "@material-ui/core/FormHelperText/FormHelperText";
import FormControl from "@material-ui/core/FormControl/FormControl";
import LoadingButton from "../../../components/elements/LoadingButton";
import axios from "axios";
import Grid from "@material-ui/core/Grid/Grid";

class AgentDashboardConfirmation extends React.Component{
    open = this.props.new;
    is_agent = this.props.user.role.name === "agent";
    state= {
        dialogOpen: (!!this.is_agent && !this.props.user.agent_confirmed),
        checked:false,
        SubmitLoading:false,
    };
    classes = this.props.classes;
    handleRequest(){
        let loginToken = localStorage.getItem('ACT');

        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.get(`${defaultVariabls.url}/agent/confirmed`, config)
            .then(response => {
                this.setState({
                    SubmitLoading:false,
                    dialogOpen:false,
                })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.allChangesSavingFailed, {
                    variant: 'error',
                });
                this.setState({
                    SubmitLoading:false
                })
            });
    }
    handleSubmit(e){
        this.setState({
            SubmitLoading:true
        })
        e.preventDefault();
        this.handleRequest();
    }
    render(){
        let{checked,SubmitLoading} = this.state;
        return (
            <>
                <Dialog
                    open={this.state.dialogOpen}
                    onClose={() => this.setState({dialogOpen:false})}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth={'xs'}
                    fullWidth
                >
                    <DialogTitle id="alert-dialog-title">
                        {Translate.welcomeToAgentPanel}
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography>{Translate.pleaseConfirmAgentTerms}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl required  component="fieldset">
                                    <FormControlLabel
                                        control={<Checkbox checked={checked} onChange={() => this.setState({checked:!checked})} />}
                                        label={
                                            <Typography className="privacy_policy">
                                                {Translate.with}
                                                {" "}
                                                <a target="_blank" href={`${defaultVariabls.website}/agent-contract`} >
                                                    {Translate.agentTerms}
                                                </a>
                                                {" "}
                                                {Translate.agentRulesConfirmation}
                                            </Typography>
                                        }
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <LoadingButton
                                    variant="contained"
                                    color="primary"
                                    disabled={!checked}
                                    onClick={this.handleSubmit.bind(this)}
                                    loading={SubmitLoading}
                                >
                                    {Translate.save}
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Dialog>
            </>
        );
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_shop: state.primary_shop,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(AgentDashboardConfirmation))));